import Konva from 'konva';

export const calculateFontSizeToFitBox = ({
  text,
  width,
  height,
  fontFamily = "Arial",
  fontStyle = "normal",
  maxFontSize = 48,
  minFontSize = 8,
  lineHeight = 1.2
}) => {

  const tempText = new Konva.Text({
    text,
    width,
    fontFamily,
    fontStyle,
    wrap: "word",
    lineHeight
  });

  let low = minFontSize;
  let high = maxFontSize;
  let best = minFontSize;

  while (low <= high) {

    const mid = Math.floor((low + high) / 2);

    tempText.fontSize(mid);

    const textHeight = tempText.height();

    if (textHeight <= height) {
      best = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }

  }

  return best;

};
